import { SharedModule } from '../shared/shared.module'
import { NgModule } from '@angular/core'
import { TeamsListComponent } from './teams-list/teams-list.component'
import { TeamsRoutingModule } from './teams-routing.module'
import { CategoryListModule } from '../libs/category-list/category-list.module'
import { TeamsListResolver } from './teams-list.resolver'
import { CollectionsBaseModule } from '../collections/collections-base.module'

@NgModule({
  imports: [SharedModule, TeamsRoutingModule, CategoryListModule, CollectionsBaseModule],
  declarations: [TeamsListComponent],
  exports: [],
  providers: [TeamsListResolver]
})
export class TeamsModule {}
